<template>
    <div
        v-bind:class="classObj"
        class="d-inline-block">
        <component
            v-bind:is="forId ? 'label' : 'span'"
            v-bind:for="forId"
            class="d-inline"
            data-test-role="input-label">
            {{ label }}
        </component>
        <slot />
        <span
            v-if="showRequired"
            data-test-role="required-indicator"
            class="text-danger">
            *
        </span>
        <pc-help-icon
            v-if="showHelp"
            v-bind:help-link="helpLink"
            v-on:click="$emit('help-clicked', $event)" />
    </div>
</template>
<script>
    export default {
        props: {
            label: { type: String, required: true },
            forId: { type: String, required: false, default: null },
            muted: { type: Boolean, required: false, default: false },
            showRequired: { type: Boolean, required: false, default: false },
            italic: { type: Boolean, required: false, default: false },
            showHelp: { type: Boolean, required: false, default: false },
            helpLink: { type: String, required: false, default: null },
            bold: { type: Boolean, required: false, default: false }
        },
        emits: ["help-clicked"],
        computed: {
            classObj() {
                return {
                    "text-body-secondary": this.muted,
                    "fst-italic": this.italic,
                    "fw-bold": this.bold
                };
            }
        }
    };
</script>
